import React, { useState, useEffect } from "react";
import { serviceSliderImg } from "../../secondUtils/constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

const ServiceImageSlider = () => {
    const [sliderSettings, setSliderSettings] = useState({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,  
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    });
    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <div className={className} onClick={onClick}>
                <button className="slider-icon-btn"><FaChevronRight /></button>
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <div className={className} onClick={onClick}>
                <button className="slider-icon-btn"><FaChevronLeft /></button>
            </div>
        );
    }
    useEffect(() => {
        const handleResize = () => {
            let slidesToShow;
            if (window.innerWidth <= 325) {
                slidesToShow = 1;
            }
            else if (window.innerWidth <= 600) {
                slidesToShow = 2;
            }
            else if (window.innerWidth <= 700) {
                slidesToShow = 3;
            }
            else if (window.innerWidth <= 800) {
                slidesToShow = 4;
            }
            else if (window.innerWidth <= 1000) {
                slidesToShow = 5;
            } else {
                slidesToShow = 6;
            }
            const updatedSettings = {
                ...sliderSettings,
                slidesToShow: slidesToShow
            };
            setSliderSettings(updatedSettings);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="service-slider-container">
            <Slider {...sliderSettings}>
                {serviceSliderImg?.map((v, i) => (
                    <div key={i}>
                        <img src={v?.img} alt="" />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default ServiceImageSlider;

